export default function Footer() {
  return (
    <footer className="bg-black py-10 sm:py-14 lg:py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row items-center lg:items-start justify-between gap-8 lg:gap-16 mb-8 lg:mb-12">
          <div className="flex flex-col items-center lg:items-start gap-4">
            <img 
              alt="Four Models" 
              className="h-14 sm:h-20 lg:h-24 object-contain" 
              src="https://static.readdy.ai/image/103ec5ada18b00c7d95516c6aa3b7243/f6ba88513f846dcaf1ba402d9a75d603.png"
            />
            <p className="text-gray-500 text-xs lg:text-sm max-w-xs text-center lg:text-left leading-relaxed">
              Há mais de 38 anos descobrindo e lançando talentos no mercado da moda, TV e entretenimento.
            </p>
          </div>

          <div className="text-center lg:text-left">
            <p className="text-yellow-500 font-bold text-xs uppercase tracking-widest mb-3">
              Evento
            </p>
            <p className="text-white font-bold text-base mb-1">Seletiva Presencial Four Models</p>
            <p className="text-gray-400 text-sm">17 de Março de 2026 às 19h30</p>
            <p className="text-gray-400 text-sm">Hotel Íbis</p>
            <p className="text-gray-400 text-sm">Tangará da Serra – MT</p>
          </div>

          <div className="text-center lg:text-left">
            <p className="text-yellow-500 font-bold text-xs uppercase tracking-widest mb-3">
              Redes Sociais
            </p>
            <div className="flex items-center gap-4 justify-center lg:justify-start">
              <a 
                href="https://www.instagram.com/fourmodelsoficial/" 
                target="_blank" 
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 bg-white/5 border border-white/10 rounded-xl flex items-center justify-center hover:border-yellow-500 hover:text-yellow-500 text-gray-400 transition-all duration-300 cursor-pointer"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a 
                href="https://www.facebook.com/fourmodelsoficial" 
                target="_blank" 
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 bg-white/5 border border-white/10 rounded-xl flex items-center justify-center hover:border-yellow-500 hover:text-yellow-500 text-gray-400 transition-all duration-300 cursor-pointer"
              >
                <i className="ri-facebook-circle-line text-xl"></i>
              </a>
              <a 
                href="https://wa.me/5566998977297?text=Ol%C3%A1!%20Tenho%20d%C3%BAvidas%20sobre%20a%20Seletiva%20Four%20Models%20em%20Tangar%C3%A1%20da%20Serra%20-%20MT%20(17%2F03%20%C3%A0s%2019h30%20no%20Hotel%20%C3%8Dbis)%20e%20gostaria%20de%20mais%20informa%C3%A7%C3%B5es!" 
                target="_blank" 
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 bg-white/5 border border-white/10 rounded-xl flex items-center justify-center hover:border-yellow-500 hover:text-yellow-500 text-gray-400 transition-all duration-300 cursor-pointer"
              >
                <i className="ri-whatsapp-line text-xl"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-5 text-center">
          <p className="text-gray-500 text-xs">
            © 2026 Four Models. Todos os direitos reservados. • <a href="https://readdy.ai/?ref=logo" target="_blank" rel="nofollow noopener noreferrer" className="hover:text-yellow-500 transition-colors font-semibold cursor-pointer">Website Builder</a>
          </p>
        </div>
      </div>
    </footer>
  );
}
